// Fixed vocabulary for tag grouping + the glyph choices shown in the tag picker. Kept here so the admin
// create/edit forms and the chip renderers share one source of truth.

// Fixed set of tag groups (categories). Deliberately NOT free-text — groups are few and consistency
// matters, so they're a closed list (unlike tag names, which are create-by-typing).
export const TAG_GROUPS = ['Project', 'Discipline', 'Priority', 'Status', 'Area', 'Other'];

// Special glyph keys. A tag's `icon` is one of these, an mdi icon name from TAG_ICONS, or null (= dot).
export const TAG_GLYPH_DOT = 'dot';
export const TAG_GLYPH_NONE = 'none';

// Curated icon set (Material Design Icons) for tag chips. Industrial/findings-leaning; swap freely.
export const TAG_ICONS = [
  'mdi-tag', 'mdi-flag', 'mdi-star', 'mdi-alert', 'mdi-alert-circle', 'mdi-information',
  'mdi-wrench', 'mdi-cog', 'mdi-hammer-wrench', 'mdi-pipe', 'mdi-water', 'mdi-fire',
  'mdi-flash', 'mdi-gauge', 'mdi-oil', 'mdi-factory', 'mdi-hard-hat', 'mdi-shield-alert',
  'mdi-clipboard-check', 'mdi-calendar', 'mdi-map-marker', 'mdi-briefcase',
];

// Resolve a tag's stored icon value to how its chip should render: 'none', 'dot', or an mdi icon name.
export function tagGlyph(icon) {
  if (icon === TAG_GLYPH_NONE) return TAG_GLYPH_NONE;
  if (!icon || icon === TAG_GLYPH_DOT) return TAG_GLYPH_DOT;
  return icon;
}
